/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Source_Web_CheckoutInputs */

const en_plan_source_web_checkout = /** @type {(inputs: Plan_Source_Web_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`web checkout`)
};

const es_plan_source_web_checkout = /** @type {(inputs: Plan_Source_Web_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pago web`)
};

/**
* | output |
* | --- |
* | "web checkout" |
*
* @param {Plan_Source_Web_CheckoutInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_source_web_checkout = /** @type {((inputs?: Plan_Source_Web_CheckoutInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Source_Web_CheckoutInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_source_web_checkout(inputs)
	return en_plan_source_web_checkout(inputs)
});